// "Hot Module Replacement" enabled environment

export const environment = {
  production: true,
  hmr: false,
  publicURL: "https://baladparking.com",
  appConfig: "appconfig.production.json",
  UploadFolder: "Production",
  DownloadXMLAllowed: false
};
